import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import api from '../lib/api';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setAuthFromCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSessionId = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate('/login');
        return;
      }
      const sessionId = match[1];

      try {
        const response = await api.post(`/auth/session?session_id=${encodeURIComponent(sessionId)}`);
        setAuthFromCallback(response.data.session_token, response.data.user);
        toast.success(`Welcome ${response.data.user.alias}`);
        const role = response.data.user.role;
        if (role === 'admin') navigate('/admin', { replace: true, state: { user: response.data.user } });
        else if (role === 'seller') navigate('/seller', { replace: true, state: { user: response.data.user } });
        else navigate('/buyer', { replace: true, state: { user: response.data.user } });
      } catch (err) {
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processSessionId();
  }, [navigate, setAuthFromCallback]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 bg-[#0055FF] flex items-center justify-center rounded">
          <Shield className="w-7 h-7 text-white animate-pulse" />
        </div>
        <div className="text-sm text-gray-600 font-mono">Establishing secure session...</div>
      </div>
    </div>
  );
}
